'use strict';

var App = require('app');
var DrinkingWaterView = require('components/devices/views/controller/drinking_water_parametrization_view');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var DrinkingWaterDialogView = Backbone.Marionette.LayoutView.extend({
    template: require('components/devices/templates/controller/drinking_water_dialog'),
    regions: {
        parameter: '#js-parameter-region',
    },

    ui: {
        save: '#js-save',
    },

    events: {
        'click @ui.save': 'save',
    },

    onRender: function () {
        this.showChildView('parameter', new DrinkingWaterView(this.options));
    },

    onShow: function () {
        $('.modal-dialog').addClass('modal-lg');
    },

    onBeforeDestroy: function () {
        $('.modal-dialog').removeClass('modal-lg');
    },

    save: function () {
        var parameter = this.getChildView('parameter').getValues();
        var req = App.request('device:set:parameter', this.options.deviceID, parameter);
        var self = this;
        $.when(req).done(function (resp) {
            if (resp === false) {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    i18n.TR('Einstellungen konnten nicht gespeichert werden.')
                );
            } else {
                Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen wurden gespeichert.'));
                self.options.callback();
            }
        });
    },
});

module.exports = DrinkingWaterDialogView;
